import script from "./UmbrellaCampaignDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UmbrellaCampaignDetail.vue?vue&type=script&setup=true&lang=js"

import "./UmbrellaCampaignDetail.vue?vue&type=style&index=0&id=9db74358&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9db74358"]])

export default __exports__